import React, { useEffect, useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../assets/Shape Logo 1.png';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../Config/Config';
const menu = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About US' },
  // { to: '/mission-vision', label: 'Mission & Vision' },
  { to: '/infrastructure', label: 'Infrastructure' },
  { to: '/services', label: 'Services' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact us' },
  { to: '/login', label: 'Login' },
];

const SideNav = () => {
  const { pathname } = useLocation();
  return (
    <nav className="hidden lg:flex fixed right-6 top-28 z-40 flex-col gap-3">
      {menu.map((item, idx) => (
        <Link key={item.to} to={item.to}>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.04 }}
            className={`px-5 py-2.5 rounded-full shadow-soft bg-white/90 backdrop-blur hover:bg-brand-primary/90 hover:text-white border border-brand-primary/30 text-sm font-medium transition-colors ${pathname===item.to ? 'bg-brand-primary/90 text-white' : ''}`}
          >
            {item.label}
          </motion.div>
        </Link>
      ))}
    </nav>
  );
};

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur border-b border-slate-200/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full  from-brand-primary to-brand-dark text-white grid place-content-center font-bold"><img src={logo} alt="logo" className="w-8 h-8" /></div>
          <span className="font-semibold text-slate-900 tracking-wide">SHAPE INTERIOR SOLUTIONS</span>
        </Link>
        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6 text-sm">
          {menu.filter(m => !['/login'].includes(m.to)).map(m => (
            <Link key={m.to} to={m.to} className="hover:text-brand-primary transition-colors">{m.label}</Link>
          ))}
          <Link to="/contact" className="px-4 py-2 rounded-lg bg-gradient-to-r from-brand-primary to-brand-dark text-white shadow-soft">Get Quote</Link>
        </nav>
        {/* Mobile button */}
        <button
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen(v => !v)}
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-md border border-slate-200 bg-white/90 text-slate-700 hover:bg-white transition"
        >
          <span className="text-xl leading-none">{open ? '✕' : '☰'}</span>
        </button>
      </div>
      {/* Mobile dropdown */}
      <div className={`${open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} md:hidden overflow-hidden transition-all duration-300 ease-out bg-white/95 backdrop-blur border-t border-slate-200/70`}> 
        <nav className="px-4 py-3 flex flex-col gap-2 text-sm">
          {menu.filter(m => !['/login'].includes(m.to)).map((m, idx) => (
            <Link
              key={m.to}
              to={m.to}
              onClick={() => setOpen(false)}
              className="px-3 py-2 rounded-md hover:bg-slate-100 transition-colors"
            >
              {m.label}
            </Link>
          ))}
          <Link to="/contact" onClick={() => setOpen(false)} className="mt-2 px-4 py-2 rounded-md bg-gradient-to-r from-brand-primary to-brand-dark text-white shadow-soft text-center">Get Quote</Link>
        </nav>
      </div>
    </header>
  );
};

const Footer = ({footerData}) => (

  
  <footer className="mt-16 bg-gradient-to-b from-white to-slate-50 border-t border-slate-200/70">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 text-sm text-slate-700">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full overflow-hidden ring-1 ring-slate-200 grid place-content-center bg-white">
              <img src={logo} alt="Shape logo" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <div className="font-semibold text-slate-900">{footerData?.companyName}</div>
              <div className="text-slate-500">Unique Job Work Solutions</div>
            </div>
          </div>
          <p className="mt-4 leading-relaxed">{footerData?.companyDescription}</p>
          <p className="mt-4">{footerData?.contactInfo?.address}</p>
        </div>

        <div>
          <h5 className="font-semibold text-slate-900 mb-3">Quick Links</h5>
          <ul className="space-y-2">
          {footerData?.quickLinks?.map((link, index) => (
            <li key={index}><Link to={link?.url} className="hover:text-brand-primary transition-colors">{link?.title}</Link></li>
          ))}
          </ul>
        </div>

        <div>
          <h5 className="font-semibold text-slate-900 mb-3">Contact</h5>
          <ul className="space-y-2">
            <li>Email: <a href="mailto:{footerData?.contactInfo?.email}" className="text-brand-primary">{footerData?.contactInfo?.email}</a></li>
            <li>Phone: <a href="tel:+919447014365" className="hover:text-brand-primary">{footerData?.contactInfo?.phone}</a></li>
            <li>Alt: <a href="tel:+9163494994699" className="hover:text-brand-primary">{footerData?.contactInfo?.alternate_no}</a></li>
            
            <li>Hours: {footerData?.contactInfo?.working_hrs}</li>
          </ul>
        </div>

        <div>
          <h5 className="font-semibold text-slate-900 mb-3">Follow us</h5>
          <div className="flex gap-3">
            <a aria-label="Instagram" href={footerData?.socialMedia?.instagram} className="w-9 h-9 rounded-full bg-white border border-slate-200 grid place-content-center shadow-soft hover:text-brand-primary">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-instagram">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
              </svg>
            </a>
            <a aria-label="Facebook" href={footerData?.socialMedia?.facebook} className="w-9 h-9 rounded-full bg-white border border-slate-200 grid place-content-center shadow-soft hover:text-brand-primary">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-facebook">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
            </a>
            <a aria-label="LinkedIn" href={footerData?.socialMedia?.linkedin} className="w-9 h-9 rounded-full bg-white border border-slate-200 grid place-content-center shadow-soft hover:text-brand-primary">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-linkedin">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                <rect width="4" height="12" x="2" y="9"/>
                <circle cx="4" cy="4" r="2"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500">
        <p>
          {/* {new Date().getFullYear()}  */}
          {footerData?.copyrightText}</p>
        <div className="mt-3 md:mt-0 flex items-center gap-4">
          <Link to="/services" className="hover:text-brand-primary">Services</Link>
          <Link to="/contact" className="hover:text-brand-primary">Get Quote</Link>
          <a href="#" className="hover:text-brand-primary">Privacy</a>
        </div>
      </div>
    </div>
  </footer>
);

const MainLayout = () => {
  const location = useLocation();
  const [footerData, setFooterData] = useState({});
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);
  useEffect(() => {
    const getData = async () => {
      const ref = doc(db, "website-management", "footer");
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setFooterData(snap.data());
      } else {
        console.log("footer document not found");
      }
    };

    getData();
   
  }, []);
  return (
    <div className="min-h-screen bg-white text-slate-800">
      <Header />
      {/* <SideNav /> */}
      <main className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
        <Outlet />
      </main>
      <Footer footerData={footerData}/>
    </div>
  );
};

export default MainLayout;
